module.exports = __webpack_public_path__ + "img/kefu.8f87b577.jpeg";